import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { locationsDataUrl: String, baseMapUrl: String };
  static targets = ["map"];

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      // Turbo Drive is displaying a preview; skip rendering the map
      return;
    }

    (async () => {
      // Fetch the base map
      const topology = await fetch(
        this.baseMapUrlValue
      ).then((response) => response.json());

      // Fetch the geocoded locations data
      const locationsData = await fetch(
        this.locationsDataUrlValue
      ).then((response) => response.json());

      // Initialize the chart
      Highcharts.mapChart(this.mapTarget, {
        chart: {
          map: topology
        },

        credits: {
          enabled: false
        },

        title: {
          text: ""
        },

        accessibility: {
          description: "Map of activated locations based on ZIP code."
        },

        mapNavigation: {
          buttonOptions: {
            align: "right"
          },
          enabled: true,
          enableMouseWheelZoom: false
        },

        tooltip: {
          headerFormat: "",
          pointFormat: "<b>{point.name}</b><br>{point.num}"
        },

        series: [
          {
            name: "Base Map",
            borderColor: "#A0A0A0",
            nullColor: "rgba(230, 230, 230, 0.3)",
            showInLegend: false
          },
          {
            // Specify points using lat/lon
            type: "mappoint",
            name: "Activated Location",
            dataLabels: {
              enabled: false
            },
            color: "rgba(37, 160, 45, 0.75)",
            data: locationsData
          }
        ]
      });
    })();
  }
}
